
<template>
  <div class="drag_r" v-show="initshow">
    <!--测验结果-->
    <div
      class="test_result clearfix"
      :class="{ unpass: dropList[0].isRight == 0 }"
      v-if="cur_data.answerShow"
      ref="testResult"
    >
      <img
        src="../../../assets/img/h5/unpass.png"
        alt=""
        v-if="dropList[0].isRight == 0"
      />
      <img src="../../../assets/img/h5/pass.png" alt="" v-else />
      <div class="answer">
        <p v-if="dropList[0].isRight == 0">{{ $t("answerFalse") }}</p>
        <p v-if="dropList[0].isRight == 1">{{ $t("answerTrue") }}</p>
        <span v-show="dropList[0].isRight == 0"
          >{{ $t("correctAnswer") }}：
          <!-- <span class="r_answer" v-for="(item , index) in dropList" :key="index">{{index+1}}.<i v-for="(e,i) in item.right_answer" :key="i">{{e}}</i></span> -->
          <span
            class="r_answer"
            v-for="(e, i) in dropList[0].right_answer"
            :key="i"
            >{{ i + 1 }}.<i>{{ e }}</i></span
          >
        </span>
      </div>
      <a href="javascript:;" @click="lookfeedback"
        ><span v-if="!feedBackShow">{{ $t("view") }}</span
        ><span v-else>{{ $t("turnOff") }}</span> 测试反馈</a
      ><br />
    </div>
    <div class="result-feedback" v-if="feedBackShow">
      <div
        class="feedback-con"
        v-if="dropList[0].isRight == 1"
        v-html="cur_data.chapter_content.feedback.right"
      ></div>
      <div
        class="feedback-con"
        v-if="dropList[0].isRight == 0"
        v-html="cur_data.chapter_content.feedback.wrong"
      ></div>
    </div>
    <div class="drag_r_con">
      <div class="big-img" v-show="img_url" @click="img_url = ''">
        <img :src="img_url" alt="" />
      </div>
      <!--题目-->
      <div class="test_top">
        <!--测验内容-->
        <div class="test_header">
          <span
            v-if="cur_data.chapter_content.quiz_type == 4"
            class="chapter-type"
            >{{ $t("Matching") }}<i></i
          ></span>
          <span
            v-if="cur_data.chapter_content.quiz_type == 5"
            class="chapter-type"
            >{{ $t("Matching2") }}<i></i
          ></span>
          <audio-btn class="exam-audio"></audio-btn>
          <p
            class="chapter-quesition"
            v-html="cur_data.chapter_content.quiz_title"
          ></p>
          <div
            class="mini-img"
            v-for="item in testdata.file_path"
            @click="img_url = item"
          >
            <img :src="item" alt="" />
            <div class="fd"></div>
          </div>
        </div>

        <div class="test_con" v-for="(item, index) in dropList" :key="index">
          <span class="xuhao">{{ index + 1 }}:</span>
          <div
            class="test_title item-drop"
            name="accurate"
            @click="chose_in(index, item)"
          >
            <!--<div class="test_title item-drop" :class="{cur:enterIndex>0 }" name="accurate" @click="chose_in(index)">-->
            {{ item.content }}
            <img
              src="../../../assets/img/h5/tz_wrong.png"
              alt=""
              v-if="item.answerStatus == 2"
              v-show="cur_data.answerShow"
            />
            <img
              src="../../../assets/img/h5/tz_right.png"
              alt=""
              v-if="item.answerStatus == 1"
              v-show="cur_data.answerShow"
            />
            <p v-for="(el, i) in item.chosedItem" :key="el.id">
              {{ el.index || el }}
              <i
                @click.stop="deleteOption(el, index, i)"
                v-if="!cur_data.answerShow"
              ></i
              ><i class="dian" v-else></i>
            </p>
            <p class="add" v-show="!cur_data.answerShow"><span></span></p>
          </div>
        </div>
        <div class="test_submit">
          <div class="unsubmit" v-if="!cur_data.answerShow">
            <a class="submit" @click="submit()">{{ $t("submit") }}</a>
          </div>
        </div>
      </div>
      <!--选项-->
      <!-- <div class="test_b"> -->
      <div class="test_bottom">
        <div class="test_test touch">
          <ul class="test_options">
            <li
              class="item trans"
              v-for="(item, index) in cur_data.chapter_content.options"
              :key="index"
              :class="{ chosed: index == dragIndex }"
            >
              <div
                class="model"
                :class="{ model_over: cur_data.answerShow }"
              ></div>
              <div @click="chose_on(item, index)">
                <!-- <div  @click="chose_on(item,index)"  target="accurate" :packet="{item:item,index:index}" ref="drag"> -->
                <div class="tit">{{ item.index }}<span></span></div>
                <div class="con">{{ item.content }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- </div> -->
      <!-- 第一次进来要展示引导操作 -->
      <test-mask v-if="$store.state.showPubAlertBgH5" type="r"></test-mask>
    </div>
  </div>
</template>
<script>
import mixins from 'components/H5/mixins/compon.js'
import audioBtn from 'components/H5/audioBtn'
import testMask from 'components/H5/test_mask'

// import { log } from 'util';
export default {
  mixins: [mixins],
  data() {
    return {
      initshow: true, // 数据没加载隐藏dom
      testdata: '', // 获取章节的数据
      alfxShow: false, // 案例分析弹框显隐
      answerShow: true, // 没有答案
      dragLeft: [],
      dragTop: [],
      divLeft: 0,
      divTop: 0,
      timeOutEvent: -1, // 长按事件的判断
      dragCan: -1, // 拖拽元素的index
      testlength: 0, // 拖拽数据条数
      dropList: [
        //   { content:'题目1',optionme:[] },
        //   { content:'题目2',optionme:[] },  { content:'题目1',optionme:[] },
      ],
      enterIndex: -1, // 拖拽进入的当前题序号
      curIndex: -1, // 拖拽结束的当前题序号
      dragIndex: -1, // 拖拽选项号
      optionsId: [], // 选项id
      chosedItem: [
        // { 'tit':'A', 'con':'选项11111'},
        //  { 'tit':'B', 'con':'选项2'},
        //  { 'tit':'C', 'con':'选项3斯的阿迪斯的阿迪斯的阿迪斯的阿迪斯阿迪斯斯的阿迪斯的阿迪斯的阿迪斯的阿迪斯阿迪斯斯的阿迪斯的阿迪斯的阿迪斯的阿迪斯阿迪斯'},
      ],
      resultHeight: 0, // 查看结果框的高度
      resultData: [], // 单多选统计数据
      isRight: 1, // 回答错误:0、正确:1
      studyTime: 0, // 记录学习的时间
      total_experience: 0,
      img_url: '', // 图片放大显示
      intervalId: 0,
      feedBackShow: false // 反馈框显示
    }
  },
  computed: {
    cur_data() {
      return this.$store.state.cur_data
    },
    next_data() {
      return this.$store.state.next_data
    }
  },
  components: {
    audioBtn,
    testMask
  },
  created() {
    this.dropList = this.cur_data.chapter_content.dry
    this.dropList[0].isRight = -1
  },
  mounted() {
    let _this = this
    this.total_experience = localStorage.getItem('left_time')
    this.$nextTick(() => {
      if (localStorage.getItem('cur_data')) {
        this.testdata = JSON.parse(localStorage.getItem('cur_data'))
      } else {
        this.testdata = this.cur_data
        localStorage.setItem('cur_data', JSON.stringify(this.cur_data))
      }
      this.index2ABC(this.cur_data.chapter_content.options)
      this.getChapterAnswer()
      this.$forceUpdate()
      $('.minitest').animate({ scrollTop: 0 }, 50)

      this.showDragDirec()// 首次学习拖拽提示
    })
    this.$store.commit('setAudioSrc', this.cur_data.audio_path || null)
    this.$store.commit('setAutoPlayer', !this.cur_data.answerShow)
  },
  methods: {
    lookfeedback() {
      this.feedBackShow = !this.feedBackShow
      let feedBackTop = $('.test_result').innerHeight()
      $('.result-feedback').css('top', feedBackTop + 'px')
    },
    /* 选择选项 */
    chose_on(item, index) {
      this.dragIndex = index
      this.chosedItem[0] = item

      if (this.cur_data.chapter_content.quiz_type == 4) {
        // 单选
        this.dropList.forEach((e, i) => {
          if (!e.chosedItem || e.chosedItem.length == 0) {
            $('.test_title').eq(i).addClass('cur')
          }
        })
      }
      if (this.testdata.chapter_content.quiz_type == 5) {
        // 多选
        $('.test_title').addClass('cur')
        this.dropList.forEach((e, i) => {
          if (e.chosedItem && e.chosedItem.length == 8) {
            $('.test_con').eq(i).find('.test_title').removeClass('cur')
          }
        })
      }
    },
    /* 选择题目 */
    chose_in(index, item) {
      if ($('.test_options li').hasClass('chosed')) {
        if (this.cur_data.chapter_content.quiz_type == 4) {
          // 单选
          if (item.chosedItem && item.chosedItem.length > 0) {
            return false
          }
          this.$set(item, 'chosedItem', JSON.parse(JSON.stringify(this.chosedItem)))
          // this.dropList[index].option = this.options
          $('.test_con').eq(index).find('.add').hide()
          $('.test_con').find('.test_title').removeClass('cur')
          // console.log(this.options)
          console.log(this.cur_data.chapter_content.dry)
        }

        if (item.chosedItem && item.chosedItem.length == 8) {
          return false
        }
        if (this.cur_data.chapter_content.quiz_type == 5) {
          // 多选 每题最多8个选项
          if (item.chosedItem && item.chosedItem.length == 7) {
            $('.test_con').eq(index).find('.add').hide()
          }
          if (item.chosedItem && item.chosedItem.length > 0) {
            item.chosedItem.push(JSON.parse(JSON.stringify(this.chosedItem))[0])
          } else {
            this.$set(item, 'chosedItem', JSON.parse(JSON.stringify(this.chosedItem)))
          }

          $('.test_con').find('.test_title').removeClass('cur')
        }
        // 选过的选项卡变灰
        $('.test_options li').eq(this.dragIndex).removeClass('chosed').children('.model').addClass('model_over')
      }
    },
    /* 提交答题，上下章节切换 */
    submit() {
      let _this = this
      let dry_list = []; let cansubmit = false
      this.dropList[0].right_answer = []
      this.dropList[0].isRight = 1
      // console.log(this.dropList)
      for (let i = 0; i < this.dropList.length; i++) {
        let e = this.dropList[i]
        let dry_list_item = {}; let optionId = []; let optionmeId = []
        if (e.chosedItem.length == 0) {
          cansubmit = true
          this.$layer.msg(this.$t('finishedSubmit'))
          return false
        }
        // 收集所有题干正确答案数据
        let every_right_answer = []
        for (let il = 0; il < this.cur_data.chapter_content.options.length; il++) {
          if (this.cur_data.chapter_content.options[il].dry_id == e.id) {
            every_right_answer.push(this.cur_data.chapter_content.options[il].index)
          }
        }
        this.dropList[0].right_answer.push(every_right_answer.toString())

        // 判断答案对错
        for (let i_a = 0; i_a < e.chosedItem.length; i_a++) {
          e.answerStatus = ''
          let optionme_item = e.chosedItem[i_a]
          if (optionme_item.dry_id != e.id) {
            e.answerStatus = 2
            this.dropList[0].isRight = 0
            break
          } else {
            if (this.dropList[0].right_answer[i].split(',').length == e.chosedItem.length) {
              e.answerStatus = 1
            } else {
              e.answerStatus = 2
            }
          }
        }
      }
      this.cur_data.answerShow = true
      this.$forceUpdate()
      console.log(this.dropList)

      this.setChaperAnswer()
      if (cansubmit) {

      }
    },
    /* 删除选项 */
    deleteOption(el, index, i) {
      //        console.log(this.dragIndex)
      // debugger
      $('.test_con').eq(index).find('.add').show()
      let list = this.dropList[index]
      list.chosedItem.splice(i, 1)
      this.dropList.splice(index, 1, list)
      if ($('.test_options').has('.chosed').length == 0) {
        // 未选中选项
        $('.test_title').removeClass('cur')
        this.dragIndex = -1
      } else {
        if (this.cur_data.chapter_content.quiz_type == 4) {
          // 单选
          $('.test_con').eq(index).find('.test_title').addClass('cur')
        }
        if (this.cur_data.chapter_content.quiz_type == 5) {
          // 多选
          if (this.dropList[index].chosedItem.length < 8) {
            $('.test_con').eq(index).find('.add').show()
            $('.test_con').eq(index).find('.test_title').addClass('cur')
          }
        }
      }
      this.cur_data.chapter_content.options.forEach((e, i) => {
        if (e.id == el.id) {
          $('.test_options li').eq(i).children('.model').removeClass('model_over')
          return false
        }
      })
    },
    /* 测验结果反馈弹框的显隐 */
    watchfk() {
      this.alfxShow = !this.alfxShow
      if (this.alfxShow) {
        $('.minitest').addClass('model-open')
      } else {
        $('.minitest').removeClass('model-open')
      }
    },
    // 展示拖拽提示
    showDragDirec() {
      // 判断是否为第一次学课
      let isFirstTime = localStorage.getItem('firstTime')
      if (!isFirstTime) {
        this.$store.commit('showPubAlertBgH5', true)
      }
    }

  },
  watch: {
    resultHeight(cur, old) {
      /* 监听测试结果框的高度来给测试分析框加top */
      //            console.log(cur, old);
      $('.alfx').css('top', cur + 'px')
      let alfxHeight = $('body').height() - $('header').height()
      $('.alfx').height(alfxHeight - cur + 'px')
    },
    feedBackShow(n) {
      if (n) {
        $('.inner-box').addClass('model-open')
      } else {
        $('.inner-box').removeClass('model-open')
      }
    }
  },
  beforeDestroy() {
    localStorage.removeItem('cur_data')
  }
}
</script>

<style lang='less' scoped>
.drag_r {
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  background-color: #fff;
  position: relative;
  // margin:0 1rem;
  box-sizing: border-box;
  &.model-open {
    position: fixed;
    width: 100%;
  }
  .result-feedback {
    width: 100%;
    height: calc(100vh - 1.87rem);
    position: absolute;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 100;
    -webkit-overflow-scrolling: touch;
    .feedback-con {
      background-color: #fff;
      min-height: 0.72rem;
      padding: 0.5rem;
      box-sizing: border-box;
    }
  }
  .test_submit {
    padding: 0.1rem 0.4rem 0.4rem;
    box-sizing: border-box;
    .submit {
      display: inline-block;
      width: 2rem;
      background-color: @basic-color;
      border-radius: 0.06rem;
      margin: 0 auto;
      font-size: 0.32rem;
      color: #fff;
      text-align: center;
      line-height: 0.78rem;
      vertical-align: middle;
    }
    .submit_done {
      .sub {
        color: @basic-color;
        background-color: #fff;
      }
      .next {
        color: @basic-color;
        background-color: #fff;
        float: right;
      }
      .sub,
      .next {
        width: 3.12rem;
        height: 0.96rem;
        border: 1px solid @basic-color;
        border-radius: 0.06rem;
        text-align: center;
        line-height: 1rem;
        display: inline-block;
        font-size: 0.3rem;
        &.cur {
          border: 1px solid #ccc;
          color: #ccc;
          opacity: 0.8;
        }
      }
    }
  }
  .test_result {
    width: 100%;
    min-height: 1.16rem;
    color: #fff;
    padding: 0.24rem 0.3rem;
    box-sizing: border-box;
    font-size: 0.2rem;
    display: flex;
    align-items: center;
    position: relative;
    background-color: @passColor;
    &.unpass {
      background-color: @unPassColor;
    }
    img {
      float: left;
      width: 0.44rem;
      height: 0.44rem;
      margin-right: 0.26rem;
      box-sizing: border-box;
    }
    .answer {
      display: inline-block;
      width: 4.6rem;
      .r_answer {
        display: inline-block;
        margin-right: 0.1rem;
      }
      p {
        font-size: 0.3rem;
      }
    }
    a {
      position: absolute;
      right: 0.3rem;
      color: #fff;
      text-decoration: underline;
    }
    .alfx {
      width: 100%;
      position: absolute;
      top: 1.2rem;
      left: 0;
      height: calc(100vh - 1.92rem);
      background-color: RGBA(127, 127, 127, 0.5);
      z-index: 100;

      .alfx_con {
        max-height: 100%;
        font-size: 0.22rem;
        padding: 0.4rem 0.46rem;
        background-color: #fff;
        overflow: auto;
        box-sizing: border-box;
        .des {
          color: #666;
        }
        .tj {
          display: inline-block;
          margin-top: 0.4rem;
          .tit {
            color: #252631;
            margin-left: 0.44rem;
          }
          p {
            margin-top: 0.16rem;
            color: #252631;
            font-size: 0.24rem;
            span {
              display: inline-block;
              width: 5rem;
              height: 0.12rem;
              background: rgba(246, 246, 246, 1);
              border-radius: 0.06rem;
              position: relative;
              margin-left: 0.18rem;
              i {
                display: inline-block;
                position: absolute;
                top: 0;
                left: 0;
                /*width: 100px;*/
                height: 0.12rem;
                border-radius: 0.06rem;
                background-color: #7f8485;
                &.max {
                  background-color: @basic-color;
                }
              }
            }
            b {
              font-size: 0.2rem;
              color: #666;
              margin-left: 0.24rem;
              font-weight: normal;
            }
          }
        }
      }
    }
  }
  .big-img {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.2);
    img {
      position: absolute;
      height: 100%;
      max-height: 4.5rem;
      left: 50%;
      top: 45%;
      transform: translate(-50%, -50%);
    }
  }
  .drag_r_con {
    margin: 0 1rem;
    overflow: hidden;
    display: flex;
  }
  .test_header {
    // width:6.16rem;
    margin: 0 auto;
    margin-top: 0.3rem;
    .exam-audio {
      display: inline-block;
    }
    .chapter-type {
      display: inline-block;
      color: #005587;
      font-size: 0.24rem;
      text-align: center;
      color: #005587;
      border-radius: 4px;
      border: 0.02rem solid #005587;
      position: relative;
      padding: 0.015rem 0.1rem;
      box-sizing: border-box;
      vertical-align: top;
      i {
        width: 0.1rem;
        height: 0.1rem;
        background: white;
        position: absolute;
        bottom: -0.07rem;
        left: 0.2rem;
        z-index: 1;
        transform: rotate(45deg);
        border-right: 0.02rem solid #005587;
        border-bottom: 0.02rem solid #005587;
      }
    }
    .chapter-quesition {
      margin: 0.2rem 0;
      padding-right: 0.4rem;
    }
    p {
      min-height: 0.6rem;
      font-size: 0.28rem;
      color: rgba(37, 38, 49, 1);
      line-height: 0.44rem;
    }
    .mini-img {
      position: relative;
      width: 1.2rem;
      height: 1rem;
      display: inline-block;
      margin-right: 0.2rem;
      @media screen and (orientation: landscape) {
        width: 1.5rem;
      }
      img {
        position: absolute;
        display: inline-block;
        width: 100%;
        height: 1rem;
        margin: 0 0.2rem 0.2rem 0;
      }
      .fd {
        position: absolute;
        width: 100%;
        height: 1rem;
        left: 0;
        top: 0;
        margin: 0 0.2rem 0.2rem 0;
        background: url("../../../assets/img/h5/img_fd.png") no-repeat center;
        -webkit-background-size: 30%;
        background-size: 30%;
      }
    }
  }
  .test_top {
    // width: 7.34rem;
    border-right: 0.08rem solid #f6f6f6;
    float: left;
    height: 6.5rem;
    overflow: scroll;
    background: #fff;
    flex: 4;
    -webkit-overflow-scrolling: touch;
    .test_top_b {
      height: 2.6rem;
      background-color: rgba(255, 0, 0, 0.3);
    }
    .test_con {
      padding: 20px 0 0;
      .xuhao {
        float: left;
        color: #252631;
        font-weight: bold;
      }
      .test_title {
        width: 6.58rem;
        min-height: 1.06rem;
        /*background:rgba(246,246,246,1);*/
        border: 1px solid rgba(216, 216, 216, 0.85);
        border-radius: 0.04rem;
        color: #666;
        margin-left: 0.4rem;
        padding: 0.12rem;
        box-sizing: border-box;
        position: relative;
        &.cur {
          border: 1px solid #4aa854;
          border-radius: 0.04rem;
        }
        &.remove_cur {
          border: 1px solid rgba(216, 216, 216, 0.85);
        }
        img {
          position: absolute;
          width: 0.26rem;
          height: 0.26rem;
          border-radius: 50%;
          right: -0.12rem;
          top: -0.12rem;
        }
        p {
          width: 6rem;
          height: 0.4rem;
          line-height: 0.4rem;
          background: #252631;
          border: 1px solid rgba(37, 38, 49, 1);
          border-radius: 0.04rem;
          margin-top: 0.1rem;
          color: #fff;
          text-indent: 0.2rem;
          position: relative;
          &.add {
            background: #f6f6f6;
            border: 1px dotted rgba(217, 221, 222, 0.85);
          }
          i {
            display: inline-block;
            width: 0.3rem;
            height: 0.3rem;
            /*border:1px solid red;*/
            float: right;
            margin-right: 0.1rem;
            margin-top: 0.04rem;
            background: url("../../../assets/img/h5/drag_del.png") no-repeat
              center;
            -webkit-background-size: 100%;
            background-size: 100%;
            &.dian {
              display: inline-block;
              float: right;
              width: 0.26rem;
              height: 0.14rem;
              background: url("../../../assets/img/h5/tz_dian.png") no-repeat
                center;
              background-size: 100%;
              margin-top: 0.12rem;
            }
          }
          span {
            position: absolute;
            display: inline-block;
            width: 0.2rem;
            height: 0.2rem;
            background: url("../../../assets/img/h5/tz_add.png") no-repeat
              center;
            -webkit-background-size: 100%;
            background-size: 100%;
            top: 50%;
            left: 50%;
            margin-top: -0.1rem;
            margin-left: -0.1rem;
          }
        }
      }
    }
    .test_submit {
      padding: 0.1rem 0.4rem 0.4rem;
      box-sizing: border-box;
      .unsubmit {
        /*margin: 40px 0 20px;*/
        .submit {
          display: inline-block;
          width: 2rem;
          background-color: @basic-color;
          border-radius: 0.06rem;
          margin: 0.3rem auto 0;
          font-size: 0.32rem;
          color: #fff;
          text-align: center;
          line-height: 0.78rem;
          vertical-align: middle;
        }
      }
      .submit_done {
        .sub {
          color: @basic-color;
          background-color: #fff;
        }
        .next {
          color: @basic-color;
          background-color: #fff;
          float: right;
        }
        .sub,
        .next {
          width: 3.12rem;
          height: 0.96rem;
          border: 1px solid @basic-color;
          border-radius: 0.06rem;
          text-align: center;
          line-height: 1rem;
          display: inline-block;
          font-size: 0.3rem;
          &.cur {
            border: 1px solid #ccc;
            color: #ccc;
            opacity: 0.8;
          }
        }
      }
    }
  }
  .test_bottom {
    flex: 2;
    float: right;
    height: 6.5rem;
    overflow-y: auto;
    overflow-x: hidden;
    background: #fff;
    -webkit-overflow-scrolling: touch;
    .test_test {
      &.touch {
        -webkit-overflow-scrolling: touch;
        -webkit-backface-visibility: hidden;
      }
    }
    .test_options {
      width: 3.8rem;
      min-height: 2.32rem;
      bottom: 0.32rem;
      flex-wrap: nowrap;
      padding: 0.3rem 0.2rem 0.3rem 0.4rem;
      box-sizing: border-box;
      z-index: 10;
      li {
        width: 100%;
        min-height: 1.94rem;
        border-radius: 2px;
        margin-right: 0.24rem;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.17);
        z-index: 10;
        position: relative;
        border: 1px solid rgba(127, 132, 133, 1);
        margin-bottom: 0.32rem;
        &.chosed {
          -webkit-transform: translateY(-0.2rem);
        }
        &.trans {
          /*-webkit-transform: translate3d(0,0,0);*/
        }
        .tit {
          height: 0.36rem;
          line-height: 0.36rem;
          color: #fff;
          background-color: #252631;
          padding: 0 0.14rem;
          // border:1Px solid rgba(127, 132, 133, 1);
          border-bottom: none;
          border-radius: 2px 2px 0 0;
          box-sizing: border-box;
          span {
            display: inline-block;
            float: right;
            width: 0.26rem;
            height: 0.14rem;
            background: url("../../../assets/img/h5/tz_dian.png") no-repeat
              center;
            background-size: 100%;
            margin-top: 0.08rem;
          }
        }
        .con {
          display: inline-block;
          color: #252631;
          padding: 0.16rem;
          min-height: 1.26rem;

          width: calc(100% - 0.32rem);
          // border-top:none;
          background-color: #fff;
          border-radius: 0 0 2px 2px;
          overflow: hidden;
          box-sizing: content-box;
          // box-sizing: border-box;
        }
        .model_over {
          background-color: rgba(255, 255, 255, 0.3);
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 100;
        }
        &.blank {
          border: none;
          min-width: 1px;
          background-color: transparent;
          box-shadow: none;
          /*position: absolute;
            z-index:100;*/
        }
      }
    }
  }
  .test_arrow {
    a {
      display: inline-block;
      width: 0.46rem;
      height: 0.8rem;
      position: fixed;
      top: 50%;
      margin-top: -0.23rem;
      background: url("../../../assets/img/h5/prev_test.png") no-repeat
        center/contain;
      &.left {
        left: 0.16rem;
      }
      &.right {
        right: 0.16rem;
        background: url("../../../assets/img/h5/next_test.png") no-repeat
          center/contain;
      }
    }
  }
}
</style>
